<template>
  <v-container>
    <v-row dense>
      <v-col>
        <field-label label="ASAS periférico" class="fill-height d-flex flex-column">
          <span
            class="big-number mt-auto"
            :class="{
              'big-number--negative': computedAsasPeriferico === '+',
              'grey--text text-lighten-1': computedAsasPeriferico === '?',
            }"
            >{{ computedAsasPeriferico }}</span
          >
        </field-label>
      </v-col>
      <v-col>
        <field-label label="Sacroileíte em imagem">
          <span
            class="big-number"
            :class="{
              'big-number--negative': computedSacroileiteImagem === '+',
              'grey--text text-lighten-1': computedSacroileiteImagem === '?',
            }"
            >{{ computedSacroileiteImagem }}</span
          >
        </field-label>
      </v-col>
    </v-row>
    <v-row dense>
      <v-col>
        <field-label label="Articulações doloridas">
          <span class="big-number" :class="[computedArticulacoesDolorosasClass]">{{
            computedArticulacoesDolorosas
          }}</span>
        </field-label>
      </v-col>
    </v-row>
    <v-row dense>
      <v-col>
        <field-label label="CASPAR">
          <span
            class="big-number"
            :class="{ 'big-number--negative': computedCaspar > 2, 'grey--text text-lighten-1': computedCaspar === '?' }"
            >{{ computedCaspar }}</span
          >
        </field-label>
      </v-col>
      <v-col>
        <field-label label="DAS-28">
          <span class="big-number" :class="[computedDas28Class]">{{ computedDas28 }}</span>
        </field-label>
      </v-col>
    </v-row>
    <v-row dense>
      <v-col>
        <field-label label="DAPSA">
          <span class="big-number" :class="[computedDapsaClass]">{{ computedDapsa }}</span>
        </field-label>
      </v-col>
      <v-col>
        <field-label label="EVA">
          <span class="big-number" :class="[computedEvaClass]">{{ computedEva }}</span>
        </field-label>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import BaseSummary from '../../general/summary/BaseSummary.vue'
import FieldLabel from '@/components/FieldLabel.vue'
import perifericMixin from '@/components/AttendanceForm/espondiloartrites/mixins/espondiloartritesPerifericAsasMixin'

export default {
  extends: BaseSummary,
  mixins: [perifericMixin],
  components: { FieldLabel },
  computed: {
    computedArticulacoesDolorosasClass() {
      if (this.computedArticulacoesDolorosas === '?') {
        return 'grey--text text-lighten-1'
      }

      if (this.computedArticulacoesDolorosas > 0 && this.computedArticulacoesDolorosas <= 2) {
        return 'yellow--text'
      } else if (this.computedArticulacoesDolorosas > 2) {
        return 'big-number--negative'
      }

      return ''
    },

    computedDas28Class() {
      if (this.computedDas28 === '?') {
        return 'grey--text text-lighten-1'
      }

      if (this.computedDas28 >= 2.6 && this.computedDas28 <= 3.2) {
        return 'yellow--text'
      } else if (this.computedDas28 > 3.2 && this.computedDas28 <= 5.1) {
        return 'orange--text'
      } else if (this.computedDas28 > 5.1) {
        return 'big-number--negative'
      }

      return ''
    },

    computedDapsaClass() {
      if (this.computedDapsa === '?') {
        return 'grey--text text-lighten-1'
      }

      if (this.computedDapsa >= 5 && this.computedDapsa <= 14) {
        return 'yellow--text'
      } else if (this.computedDapsa > 14 && this.computedDapsa <= 28) {
        return 'orange--text'
      } else if (this.computedDapsa > 28) {
        return 'big-number--negative'
      }

      return ''
    },
  },

  methods: {
    getSummaryData() {
      return {
        asasPeriferico: { value: this.computedAsasPeriferico ?? '', text: 'ASAS periférico' },
        sacroileiteImagem: { value: this.computedSacroileiteImagem ?? '', text: 'Sacroileíte em imagem' },
        articulacoesDoloridas: { value: this.computedArticulacoesDolorosas ?? '', text: 'Articulações doloridas' },
        caspar: { value: this.computedCaspar ?? '', text: 'CASPAR' },
        das28: { value: this.computedDas28 ?? '', text: 'DAS-28' },
        dapsa: { value: this.computedDapsa ?? '', text: 'DAPSA' },
        eva: { value: this.computedEva ?? '', text: 'EVA' },
      }
    },
  },
}
</script>

<style scoped>
.big-number {
  font-weight: medium;
  color: green;
  font-size: 2.5rem;
}
.big-number--negative {
  color: red;
}
</style>
